import { ProductDoc } from '@gooduncles/gu-app-schema';
import { FC } from 'react';

import useDragScroll from 'src/hooks/useDragScroll';

import ProductSquareItem from 'src/components/organisms/ProductItem/ProductSquareItem';

import SkeletonSquareItem from '../../ProductItem/SkeletonSquareItem/SkeletonSquareItem';
import classes from './HorizontalProductList.module.scss';

interface HorizontalProductListProps {
  products: ProductDoc[];
  loading: boolean;
  showBadge?: boolean;
}

const HorizontalProductList: FC<HorizontalProductListProps> = ({ products, loading, showBadge }) => {
  // 상품이 없고 로딩 중일 때만 Skeleton을 표시
  const shouldShowSkeleton = loading && products.length === 0;

  // 드래그 스크롤 기능
  const { scrollRef, isDragging, handlers } = useDragScroll();

  return (
    <div
      ref={scrollRef}
      className={`${classes.horizontalProductList} ${loading && products.length > 0 ? classes.loading : ''} ${
        isDragging ? classes.dragging : ''
      }`}
      {...handlers}>
      {shouldShowSkeleton
        ? [...Array(3)].map((_, index) => <SkeletonSquareItem key={index} />)
        : products.map((product) => (
            <ProductSquareItem key={product.productId} product={product} horizontal showBadge={showBadge} />
          ))}
    </div>
  );
};

export default HorizontalProductList;
